import { AccessibilityStore } from "./store.js"

const $ = require("jquery")

// TODO: think about line-height
export default {
  resetFonts: function (element) {
    const jqElement = $(element).not(".MathJax_Display *") // exclude mathjax elements
    if (!jqElement.closest(".ck-editor-media").length) jqElement.css("font-size", "")
    jqElement.removeAttr("data-font-size")
    this.setFonts(jqElement)
  },

  setFonts: function (element) {
    element.each(function () {
      const jqElement = $(this)

      if (!jqElement.attr("data-font-size")) {
        const size = parseInt(jqElement.css("font-size"))
        jqElement.attr("data-font-size", size)
      }
    })

    AccessibilityStore.calculateFonts(element)
    App.vent.trigger("window:resize", { fromAccessibilityHandler: true })
  },

  setFontsPage: function (controller, viewEvent = "render") {
    const a11y = this

    for (const key in controller.views) {
      const view = controller.views[key]

      controller.listenTo(
        controller.views[key],
        viewEvent,

        function () {
          const element = this.$el.find("*")
          a11y.setFonts(element)
        }.bind(controller.views[key]),
      )

      const element = view.$el.find("*")
      a11y.setFonts(element)
    }
  },
}
